import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Tool from './utils/tool'
import Http from './utils/http'
import axios from 'axios'
import "@/assets/less/review/review.styl";  // 学习中心 样式

import VueI18n from 'vue-i18n'

Vue.config.productionTip = false
Vue.prototype.$store = store;
Vue.prototype.$Tool = Tool;
Vue.prototype.$Http = Http;

Vue.config.productionTip = false
let winHost = window.location.host

axios.interceptors.request.use(
  config => {
    if (config.method == 'get') {
      config.params['visitpost'] = 'pc'
    } else if (config.method == 'post') {
      config.data = `${config.data}&visitpost=pc`
    }
    return config;
  }
)

let language_type: any
if (Tool.getStorage('languageType')) {
  language_type = Tool.getStorage('languageType')
} else {
  if (winHost == 'stupc.kidcastle.cn') {
    language_type = 'zh'
  } else if (winHost == 'stupc.kidcastleapp.tw') {
    language_type = 'tw'
  } else {
    // language_type = 'tw'
    language_type = 'zh'
  }
}

Vue.prototype.$languageType = language_type
Tool.setStorage('languageType', language_type)
store.dispatch("setLanguageType", language_type);

Vue.prototype.$eventBus = new Vue

if (Tool.getStorage("token") && Tool.getStorage("member_id")) {
  const token = Tool.getStorage("token");
  const member_id = Tool.getStorage("member_id");
  store.dispatch("setUserToken", token);
  store.dispatch("setMemberId", member_id);
}

if (Tool.getStorage('Global_TXT')) {
  store.dispatch("setGlobalTxt", Tool.getStorage('Global_TXT'))
}
//当前孩子信息
if (Tool.getStorage('currentStuInfo')) {
  const currentStuInfo = Tool.getStorage("currentStuInfo");
  store.dispatch("setCurrentChild", currentStuInfo);
  Http.getUserMenu({
    member_id: store.state.member_id,
    token: store.state.token,
    student_id: currentStuInfo.student_id,
    class_branch: currentStuInfo.class_branch,
  }).then(res => {
    const { error, result } = res.data
    if (error == 0) {
      store.dispatch("setGlobalTxt", result.list)
      Tool.setStorage("Global_TXT", result.list);
    } else {
      store.dispatch("setGlobalTxt", {})
      Tool.setStorage("Global_TXT", {});
    }
  })
}
//背景音乐是否播放
if (Tool.getStorage('isPlay')) {
  const isPlay = Tool.getStorage("isPlay");
  store.dispatch("setbgMusic", isPlay);
}
//存储题目答案
if (Tool.getStorage('answer_list')) {
  const answer_list = Tool.getStorage("answer_list");
  store.dispatch("setAnswerList", answer_list);
}
//存储考试剩余时间
if (Tool.getStorage('remainTime')) {
  const remainTime = Tool.getStorage("remainTime");
  store.dispatch("setRemainTime", remainTime);
}
//存储 当前题目信息 - 头部信息
if (Tool.getStorage('InfoNameQuestion')) {
  const InfoNameQuestion = Tool.getStorage("InfoNameQuestion");
  store.dispatch("setInfoNameQuestion", InfoNameQuestion);
}
if (Tool.getStorage('InfoAllQuestion')) {
  const InfoAllQuestion = Tool.getStorage("InfoAllQuestion");
  store.dispatch("setInfoAllQuestion", InfoAllQuestion);
}
if (Tool.getStorage('InfocurrentQuestion')) {
  const InfocurrentQuestion = Tool.getStorage("InfocurrentQuestion");
  store.dispatch("setInfocurrentQuestion", InfocurrentQuestion);
}
//存储 试题分析 当前题目信息 - 头部信息
if (Tool.getStorage('InfoNameQuestion1')) {
  const InfoNameQuestion1 = Tool.getStorage("InfoNameQuestion1");
  store.dispatch("setInfoNameQuestion1", InfoNameQuestion1);
}
if (Tool.getStorage('InfoAllQuestion1')) {
  const InfoAllQuestion1 = Tool.getStorage("InfoAllQuestion1");
  store.dispatch("setInfoAllQuestion1", InfoAllQuestion1);
}
if (Tool.getStorage('InfocurrentQuestion1')) {
  const InfocurrentQuestion1 = Tool.getStorage("InfocurrentQuestion1");
  store.dispatch("setInfocurrentQuestion1", InfocurrentQuestion1);
}
//当前教材id
if (Tool.getStorage('textBookId')) {
  const textBookId = Tool.getStorage("textBookId");
  store.dispatch("settextBookId", textBookId);
}
//当前教材 名称
if (Tool.getStorage('textbookCnname')) {
  const textbookCnname = Tool.getStorage("textbookCnname");
  store.dispatch("settextbookCnname", textbookCnname);
}
//考试提交获取的信息
if (Tool.getStorage('getCodeInfo')) {
  const getCodeInfo = Tool.getStorage("getCodeInfo");
  store.dispatch("setgetCodeInfo", getCodeInfo);
}
//简转繁
if (Tool.getStorage('languageType')) {
  const languageType = Tool.getStorage('languageType') ? Tool.getStorage('languageType') : 'zh';
  store.dispatch("setLanguageType", languageType);
}
// Tool.getStorage('language_type') ? Tool.getStorage('language_type') : 'zh',
//http request 拦截器
axios.interceptors.request.use(
  config => {
    if (config.method == 'get') {
      !config.params.language_type && (config.params.language_type = language_type);
    } else if (config.method == 'post') {
      (config.data.indexOf('language_type=') < 0) && (config.data = `${config.data}&language_type=${language_type}`);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.result && response.data.result.tokeninc && response.data.result.tokeninc == 0) {
      window.localStorage.clear()
      window.location.replace('/login')
    } else {
      return response;
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)

Vue.use(VueI18n);
// 语言切换
const i18n = new VueI18n({
  locale: Tool.getStorage('languageType') ? Tool.getStorage('languageType') : 'zh',
  messages: {
    'zh': require('./langs/cn.js'),
    'tw': require('./langs/tw.js')
    // 'zh': Object.assign(require('./langs/cn.js'), zhLocale),//将我们项目中的语言包与Element的语言包进行合并
    // // 'en': Object.assign(require('./langs/en.js'), enLocale),
    // 'tw': Object.assign(require('./langs/tw.js'), zhTwLocale),
  },
});
// locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
